import { CartServices,CartServicesEsponal,ProductType, Service,PAGEACTIVITY } from './../constants/actionType'
import { InHomeUtils } from './inhomeUtils'
import { catchJSException,logOtherInfo,detailsInfo } from './../service/logService'

export const getCartDataDefault = () => {
    let cartData = { serviceHeaders: null, internet: null, channel: null,intrnlChannel:null, listing: null,
        streamService:null, equipments: [], oneTimeCharge: [], Promotions: [],
        rewardOffers: [], youtubePrd:[], channelsNotInPack:[], fiosFiveSelectedChannels : [], perks: [] }
    return cartData;
}

export const getCartHeader = (cartResponse,visitId=null) => {
    let cartHeader = [];
    cartHeader = getCartHeaderArray(cartResponse,visitId);
    return cartHeader;
}

export const getCartHeaderArray = (cartResponse, visitId=null) => {
    let tierHeader = [];
    let tierHeaders = { tierHeader: null };
    try{  
        if(InHomeUtils.isNotNull(cartResponse)){
            cartResponse.forEach(tierHead =>{
                tierHeaders.tierHeader = Object.assign({
                    cartID: tierHead.id,
                    title: tierHead.tierTitle,
                    totalPrice: tierHead.totalMonthlyPrice,
                    totalNrcPrice: tierHead.totalNrcPrice,
                    monthlyRcPrice: tierHead.monthlyRcPrice,
                    monthlyNrcPrice: tierHead.monthlyNrcPrice
                })
                tierHeader.push(tierHeaders.tierHeader);
            })
        }
        else{
            logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.CART, visitId, 'getCartHeaderArray', PAGEACTIVITY.MSG.cartResponseNull, PAGEACTIVITY.UA));
        }
    }
    catch (ex) {
        catchJSException('cartUtility', visitId, 'getCartHeaderArray', ex);
    }
    
    return tierHeader;
}

export const getSubProduct = (subSection, visitId) => {
    let subProducts = [];
    try {
        subSection.forEach(subSec => {
            subProducts.push.apply(subProducts, subSec.products);
        })
    }
    catch (ex) {
        catchJSException('cartUtility', visitId, 'getSubProduct', ex);
    }

    return subProducts;
}

// Function to replace text for the cartData
export function replaceCartDataText(data, dataType) {
    let replacedData = data;
    if (Array.isArray(data) && dataType === CartServices.specialoffer) {
        replacedData = data.map(p => {
            let promoText = p?.promoText || null;
            if (typeof p?.promoText === "string" && (p?.promoText?.includes("Xbox Gaming Bundle") || p?.OfferText?.includes("Xbox Gaming Bundle") || p?.promoText?.includes("Xbox Bundle") || p?.OfferText?.includes("Xbox Bundle"))) {
                promoText = "Xbox Headset + Controller";
            }
            if (typeof p?.promoText === "string" && (p?.promoText?.includes("Xbox Series S Console On Us") || p?.OfferText?.includes("Xbox Series S Console On Us"))) {
                promoText = "Xbox Series S";
            }
            return {
                ...p,
                promoText: promoText,
                OfferText: promoText,
            }
        });
    } else if (Array.isArray(data) && dataType === CartServices.Offers) {
        replacedData = data.map(p => {
            let promoText = p?.promoText || null;
            if ((typeof p?.promoText === "string" && p?.promoText?.toLowerCase?.()?.includes?.("youtube premium") && p?.promoText?.toLowerCase?.()?.includes?.("6 months")) || (typeof p?.OfferText === "string" && p?.OfferText?.toLowerCase?.()?.includes?.("youtube premium") && p?.OfferText?.toLowerCase?.()?.includes?.("6 months"))) {
                promoText = "YouTube Premium Special Gift Savings";
            }
            return {
                ...p,
                promoText: promoText,
                OfferText: promoText,
            }
        });
    }
    return replacedData;
}

export const getCartData = (cartResponse,visitId=null) => {
    let cartData = getCartDataDefault();

    let cartspilitData = [];
    try{
        if(InHomeUtils.isNotNull(cartResponse)) {
            for (var cartdatas in cartResponse) {
                for (var secIndex in cartResponse[cartdatas].sections.section) {
                    //Render Service Header and Special Offers and Offers 
                    let cartSection = cartResponse[cartdatas].sections.section[secIndex];
                    if (cartSection.sectionName.toLowerCase() === CartServices.Service || cartSection.sectionName.toLowerCase() === CartServicesEsponal.service) {
                        for (let serviceprod in cartSection.subSections.subSection) {
                            let cartSubSection = cartSection.subSections.subSection[serviceprod];
                            if (cartSubSection.sectionType !== undefined &&  cartSubSection.sectionType !== null) {
                                switch (cartSubSection.sectionType) {
                                    case CartServices.bundle:
                                    case CartServices.dataStandalone:
                                    case CartServices.tvStandalone:
                                    case CartServices.voiceStandalone:
                                        // Section Header should check with Standalone || Bundles 
                                        let subSectionProducts = cartSubSection && cartSubSection.products && cartSubSection.products.length || 0;
                                        if (serviceprod < 1) {
                                            cartData.serviceHeaders = Object.assign({
                                                servicehead: cartSubSection.products,
                                                // servicePromos: cartSubSection.promos,
                                                totalPrice: cartSubSection.sectionTotalprice,
                                                title: cartSubSection.title
                                            })

                                            if (cartSubSection.sectionType === CartServices.tvStandalone && subSectionProducts > 0) {
                                                let cartProducts = '';
                                                cartSubSection.products.forEach(function (prod) {
                                                    if (cartProducts.indexOf(prod.prodId) < 0) {
                                                        if (InHomeUtils.isNotEmpty(prod.prodType) && prod.prodType === "BASIC_FF") {
                                                            cartData.fiosFiveSelectedChannels.push(prod);
                                                        }
                                                    }
                                                });
                                            }
                                        }
                                        else {
                                            if (subSectionProducts > 0) {
                                                let cartProducts='';
                                                let prodId = cartSubSection.products[0].prodId;
                                                if(prodId !== ''){
                                                    cartData.serviceHeaders.servicehead.forEach(function (prod) {
                                                        cartProducts += prod.prodId +",";
                                                    });
                                                }

                                                cartSubSection.products.forEach(function (prod) {
                                                    if (cartProducts.indexOf(prod.prodId) < 0) {
                                                        if (cartSubSection.sectionType === CartServices.tvStandalone && InHomeUtils.isNotEmpty(prod.prodType) && prod.prodType === "BASIC_FF") {
                                                            cartData.fiosFiveSelectedChannels.push(prod);
                                                        } else{
                                                            cartData.serviceHeaders.servicehead.push(prod);
                                                        }
                                                    }
                                                });
                                            }
                                        }
                                        break;

                                    case CartServices.internet:
                                        //Rendering Internet Products Like VASIP Products
                                        cartData.internet = Object.assign({
                                            internetProds: cartSubSection.products,
                                            internetPromos: cartSubSection.promos,
                                            internetTotalPrice: cartSubSection.sectionTotalprice,
                                            internettitle: cartSubSection.title
                                        })
                                        break;

                                    case CartServices.channel:
                                        // Rendering TV Section Here 
                                        cartData.channel = Object.assign({
                                            channelsProds: cartSubSection.products,
                                            channelsPromos: cartSubSection.promos,
                                            channelsTotalprice: cartSubSection.sectionTotalprice,
                                            channelstitle: cartSubSection.title
                                        })
                                        break;
                                        case CartServices.intrnlChannel:
                                            // Rendering international TV Section Here 
                                            cartData.intrnlChannel = Object.assign({
                                                intrnlChannelsProds: cartSubSection.products,
                                                intrnlChannelsPromos: cartSubSection.promos,
                                                intrnlChannelsTotalprice: cartSubSection.sectionTotalprice,
                                                intrnlChannelstitle: cartSubSection.title
                                            })
                                            break;
                                        case CartServices.channelsNotInPack:
                                        // Rendering TV Section Here 
                                        cartData.channelsNotInPack = Object.assign({
                                            channelsProds: cartSubSection.products,
                                            channelsPromos: cartSubSection.promos,
                                            channelsTotalprice: cartSubSection.sectionTotalprice,
                                            channelstitle: cartSubSection.title
                                        })
                                        break;

                                    case CartServices.listing:
                                        //Rendering Phone Section Here
                                        cartData.listing = Object.assign({
                                            listingProds: cartSubSection.products,
                                            listingPromos: cartSubSection.promos,
                                            listingTotalprice: cartSubSection.sectionTotalprice,
                                            listingtitle: cartSubSection.title
                                        })

                                        break;

                                    case CartServices.streamService:
                                        cartData.streamService = Object.assign({
                                            streamServiceProds: cartSubSection.products,
                                            streamServicePromos: cartSubSection.promos,
                                            streamServiceTotalprice: cartSubSection.sectionTotalprice,
                                            streamServicetitle: cartSubSection.title
                                        })
                                        break;
                                    default:
                                        break;
                                }
                            }
                        }
                    }
                    else if (cartSection.sectionName === CartServices.equipment || 
                        cartSection.sectionName === CartServicesEsponal.equipment) {
                        let equipment = []
                        cartSection.subSections.subSection.forEach(subSec =>{
                            if(subSec.products[0].prodId !=="NODCT" && subSec.products[0].prodId !=="NORECORD" && subSec.products[0].prodId !=="NOVROOM"){
                                equipment.push.apply(equipment, subSec.products);
                            }
                        })
                        cartData.equipments = Object.assign({ equipment: equipment })
                    }
                    else if (cartSection.sectionName === CartServices.streamDevice) {
                        let streamDev = []
                        streamDev = getSubProduct(cartSection.subSections.subSection, visitId);
                        cartData.streamDev = Object.assign({ streamDevProds: streamDev })
                    }
                    else if (cartSection.sectionName === CartServices.Promotions ||
                        cartSection.sectionName === CartServicesEsponal.Promotions) {
                        let Promotions = []
                        let PromoSectionTotalPrice = '';
                        let rewardOffers = []
                        let youtubePrd=[];
                        cartSection.subSections.subSection.forEach(subSec =>{
                            if (subSec && (subSec.sectionType === CartServices.Offers || subSec.sectionType === CartServicesEsponal.Offers)) {
                                let replacedPromos = replaceCartDataText(subSec?.promos, CartServices.Offers);
                                Promotions.push.apply(Promotions, replacedPromos);
                                PromoSectionTotalPrice= InHomeUtils.isNotNull(subSec.sectionTotalprice)?subSec.sectionTotalprice:"";
                            }
                            else if (subSec && subSec.sectionType === CartServices.specialoffer) {
                                if (typeof subSec.products !== "undefined" && subSec.products !== null && subSec.products.length > 0 && subSec.products[0].prodType === Service.streamServ) {
                                    youtubePrd.push(subSec.products[0]);
                                } 
                                let replacedPromos = replaceCartDataText(subSec?.promos, CartServices.specialoffer);
                                rewardOffers.push.apply(rewardOffers, replacedPromos);
                                // rewardOffers.push.apply(rewardOffers, subSec.promos);
                                //if(youtubePrd!==null && youtubePrd.length>0){
                                //    rewardOffers.push.apply(rewardOffers, youtubePrd);
                                //}
                             }
                        })
                        cartData.Promotions = Object.assign({ promoSectionTotalPrice :PromoSectionTotalPrice,promotions: Promotions })
                        cartData.rewardOffers = Object.assign({ rewardOffers: rewardOffers })
                        cartData.youtubePrd = Object.assign({ youtubePrd: youtubePrd })
                    }
                    else if (cartSection.sectionName === CartServices.oneTimeCharges ||
                        cartSection.sectionName === CartServicesEsponal.oneTimeCharges ) {
                        let oneTimeCharge = []
                        oneTimeCharge = getSubProduct(cartSection.subSections.subSection, visitId);
                        cartData.oneTimeCharge = Object.assign({ onetimecharge: oneTimeCharge })
                    } else if(cartSection.sectionName === CartServices.Perks) {
                        console.log('****** perks data 233', cartSection);
                        const prods = cartSection?.subSections?.subSection?.[0]?.products || [];
                        cartData.perks = Object.assign({ perks: prods });
                    }
                }
                cartspilitData.push(cartData);
                cartData = {};
            }
        }
        else{
            logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.CART, visitId, 'getCartData', PAGEACTIVITY.MSG.cartResponseNull, PAGEACTIVITY.UA));
        }         
    }
    catch (ex) {
        catchJSException('cartUtility', visitId, 'getCartData', ex);
    }

    return cartspilitData
}

export const getCartProducts = (cartResponse,visitId=null) => {
    let cartProduct = {
        Bundle: null, DataProduct: null, TvProduct: null, VoiceProduct: null,
        CartSubProduct: null, Channels: null, Listing: null, VasProduct: null, StreamingService: null
    };

    try{
        let service = getServiceSection(cartResponse,visitId);
        if(InHomeUtils.isNotNull(service)) {
            service.subSections.subSection.forEach(subSec => {
                if (InHomeUtils.isNotNull(subSec.sectionType)) {
                    if (InHomeUtils.isNotNull(subSec.products)) {
                        subSec.products.forEach(prod => {
                            prod["displayPrice"] = prod.price;
                        })
                    }

                    switch (subSec.sectionType) {
                        case CartServices.bundle:
                            cartProduct.Bundle = Object.assign({
                                bundleProd: subSec.products,
                            })
                            break;

                        case CartServices.dataStandalone:
                            cartProduct.DataProduct = Object.assign({
                                dataProd: subSec.products,
                            })
                            break;

                        case CartServices.tvStandalone:
                            cartProduct.TvProduct = Object.assign({
                                tvProd: subSec.products,
                            })
                            break;

                        case CartServices.voiceStandalone:
                            cartProduct.VoiceProduct = Object.assign({
                                voiceProd: subSec.products,
                            })
                            break;

                        case CartServices.listing:
                            cartProduct.Listing = Object.assign({
                                listingProd: subSec.products,
                            })
                            break;

                        case CartServices.channel:
                            cartProduct.Channels = Object.assign({
                                channelProd: subSec.products,
                            })
                            break;
                            case CartServices.intrnlChannel:
                                cartProduct.intrnlChannels = Object.assign({
                                    intrnlChannelProd: subSec.products,
                                })
                                break;

                        case CartServices.channelsNotInPack:
                            cartProduct.Channels = Object.assign({
                                channelProd: subSec.products,
                            })
                            break;

                        case CartServices.internet:
                            let vasSupported = [];
                            let vasUnSupported = [];
                            if (subSec.products !== null) {
                                subSec.products.forEach(prod => {
                                    //prod["prodType"] = "PPP";
                                    if (InHomeUtils.isNotEmpty(prod.isProductSupported) && prod.isProductSupported === 'No') {
                                        vasUnSupported.push(prod);
                                    } else {
                                        vasSupported.push(prod);
                                    }
                                })

                                if (vasUnSupported.length > 0) {
                                    vasUnSupported.forEach(function (vasProd) {
                                        vasSupported.push(vasProd);
                                    });
                                }
                            }
                            cartProduct.Techsure = Object.assign({
                                VasProduct: vasSupported,
                            })
                            break;
                        case CartServices.streamService:
                            let streamService = [];
                            subSec.products.forEach(prod => {
                                streamService.push(prod);
                            })
                            cartProduct.StreamingService = Object.assign({ StreamingService: streamService })
                            break;

                        default:
                            break;
                    }
                }
            })
                        
            cartProduct.CartSubProduct = getCartSubProducts(cartResponse,visitId); 
        }
        else{
            logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.CART, visitId, 'getCartProducts', PAGEACTIVITY.MSG.cartServiceNull, PAGEACTIVITY.UA));
        }
        
    }
    catch (ex) {
        catchJSException('cartUtility', visitId, 'getCartProducts', ex);
    }
    
    return cartProduct;
}

export const getCartSubProducts = (cartResponse,visitId=null) => {
    let cartSubProduct = { Equipment: null, OneTimeCharges: null, Promotions: null, SpecialOffers:null, StreamingDeviceProduct:null };
    try{
        let service = getSubServiceSection(cartResponse,visitId);

        service.forEach(serv => {
            if (InHomeUtils.isNotNull(serv.sectionName)) {
                switch (serv.sectionName) {
                    case CartServices.equipment || CartServicesEsponal.equipment:
                        let equipment = [];
                        equipment = getSubProduct(serv.subSections.subSection, visitId);
                        cartSubProduct.Equipment = Object.assign({ equipment: equipment })
                        break;

                    case CartServices.oneTimeCharges || CartServicesEsponal.oneTimeCharges:
                        let oneTimeCharge = [];
                        oneTimeCharge = getSubProduct(serv.subSections.subSection, visitId);
                        cartSubProduct.OneTimeCharges = Object.assign({ oneTimeCharge: oneTimeCharge })
                        break;

                    case CartServices.Promotions || CartServicesEsponal.Promotions:
                        let promotions = [];
                        let specialoffers = [];
                        let rewardoffers = [];
                        serv.subSections.subSection.forEach(subSec => {
                            if (subSec.sectionType === CartServices.specialoffer) {
                                if (InHomeUtils.isNotEmpty(subSec.products)) {
                                    specialoffers.push.apply(specialoffers, subSec.products);
                                }
                                if (InHomeUtils.isNotEmpty(subSec.promos)) {
                                    rewardoffers.push.apply(rewardoffers, subSec.promos);
                                }
                            }
                            else {
                                promotions.push.apply(promotions, subSec.promos);
                            }
                        })

                        cartSubProduct.Promotions = Object.assign({ promotions: promotions })
                        cartSubProduct.SpecialOffers = Object.assign({ specialoffers: specialoffers, rewardoffers: rewardoffers })
                        break;

                    case CartServices.streamDevice:                    
                        let streamDeviceProduct = [];
                        streamDeviceProduct = getSubProduct(serv.subSections.subSection, visitId);
                        cartSubProduct.StreamingDeviceProduct = Object.assign({ streamDeviceProduct: streamDeviceProduct })
                        break;                    
                    default:
                        break;
                }
            }
        })
    }
    catch (ex) {
        catchJSException('cartUtility', visitId, 'getCartSubProducts', ex);
    }
    return cartSubProduct;
}

export const checkServiceAdded = (cartOrderDetail, visitId = null) => {
    
    let selectedServices = { isInternet: false, isTv: false, isVoice: false, isYouTubeTV: false };

    try{
        //servicesOrdered:"DATA,VIDEO,FIOS_VOICE"
        if (InHomeUtils.isNotNull(cartOrderDetail) && InHomeUtils.isNotEmpty(cartOrderDetail.servicesOrdered)) {
            selectedServices.isInternet = cartOrderDetail.servicesOrdered.indexOf('DATA') > -1;
            selectedServices.isTv = cartOrderDetail.servicesOrdered.indexOf('VIDEO') > -1;
            selectedServices.isVoice = cartOrderDetail.servicesOrdered.indexOf('VOICE') > -1;
        }
    }
    catch (ex) {
        catchJSException('cartUtility', visitId, 'checkServiceAdded', ex);
    }
    
    return selectedServices;
}

export const getSelectedInternet = (cartResponse,visitId=null) => {
    
    //find the internet sub section
    let dataSection = null;
    try{
        //get the service section data from the cart response 
        let service = getServiceSection(cartResponse,visitId);
        if (InHomeUtils.isNotNull(service) && InHomeUtils.isNotNull(service.subSections) && InHomeUtils.isNotNull(service.subSections.subSection)) {
            let subSection = service.subSections.subSection;
            subSection.forEach(subSec => {
                if (InHomeUtils.isNotNull(subSec.sectionType) && (subSec.sectionType.toLowerCase().indexOf("data") > -1 || subSec.sectionType === CartServices.bundle) || subSec.sectionType === CartServices.dataStandalone) {
                    dataSection = subSec.products.filter(prod => prod.prodType === 'FTTPD');
                    if (InHomeUtils.isNotNull(dataSection) && dataSection.length > 0) {
                        return dataSection;
                    }
                }
            })
        }
    }
    catch (ex) {
        catchJSException('cartUtility', visitId, 'getSelectedInternet', ex);
    }
    
    return dataSection;
}

export const getSelectedTv = (cartResponse,visitId=null) => {    
    let tvSection = null;
    try{
        //get the service section data from the cart response 
        let service = getServiceSection(cartResponse,visitId);
        //find the tv sub section
        if (InHomeUtils.isNotNull(service) && InHomeUtils.isNotNull(service.subSections) && InHomeUtils.isNotNull(service.subSections.subSection)) {
            let subSection = service.subSections.subSection;
            subSection.forEach(function (subSec) {
                if (subSec.sectionType.toLowerCase().indexOf("tv") > -1) {
                    tvSection = subSec.products[0];
                }
                else if (subSec.sectionType === CartServices.bundle) {
                    let products = subSec.products;
                    tvSection = products.filter(prod => (prod.prodType === ProductType.TV_BASIC) || (prod.prodType === ProductType.TV_BASICDIFF));
                    tvSection = (tvSection !== undefined && tvSection!==null && tvSection.length > 0) ? tvSection[0] : null;
                }
            })
        }
    }
    catch (ex) {
        catchJSException('cartUtility', visitId, 'getSelectedTv', ex);
    }
    return tvSection;
}

export const getSelectedVoice = (cartResponse,visitId=null) => { 
    
    let voiceSection = null;
    try{
        //get the service section data from the cart response 
        let service = getServiceSection(cartResponse,visitId);
        //find the voice sub section
        if (InHomeUtils.isNotNull(service) && InHomeUtils.isNotNull(service.subSections) && InHomeUtils.isNotNull(service.subSections.subSection)) {
            let subSection = service.subSections.subSection;
            subSection.forEach(function (subSec) {
                if (subSec.sectionType.toLowerCase().indexOf("voice") > -1) {
                    voiceSection = subSec.products[0];
                }
                else if (subSec.sectionType === CartServices.bundle) {
                    let products = subSec.products;
                    voiceSection = products.filter(prod => prod.prodType === ProductType.VOICE_PRIMARY);
                }
                if (InHomeUtils.isNotNull(voiceSection) && voiceSection.length > 0){
                    return voiceSection;
                }
            });
        }
    }
    catch (ex) {
        catchJSException('cartUtility', visitId, 'getSelectedVoice', ex);
    }
    return voiceSection;
}

const getServiceSection = (cartResponse,visitId=null) => {   
    try {
       if(Array.isArray(cartResponse)) return null;
    else
        return cartResponse.tierContent[0].sections.section.length > 0 ? cartResponse.tierContent[0].sections.section[0] : null;
    }
    catch (ex) {
        catchJSException('cartUtility', visitId, 'getServiceSection', ex);
    }
}

const getSubServiceSection = (cartResponse,visitId=null) => {
    try {
        return cartResponse.tierContent[0].sections.section;
    }
    catch (ex) {
        catchJSException('cartUtility', visitId, 'getSubServiceSection', ex);
    }
}

export const getSelectedChannels = (cartResponse,visitId=null) => {
    let channelSection = null;
    try{
        //get the service section data from the cart response 
        let service = getServiceSection(cartResponse,visitId);
        //find the channel sub section
        if (InHomeUtils.isNotNull(service) && InHomeUtils.isNotNull(service.subSections) && InHomeUtils.isNotNull(service.subSections.subSection)) {
            let subSection = service.subSections.subSection;
            subSection.forEach(function (subSec) {
                if (subSec.sectionType != null && subSec.sectionType.toLowerCase().indexOf("channel") > -1) {
                    channelSection = subSec.products;
                    return channelSection;
                }
            });
        }
    }
    catch (ex) {
        catchJSException('cartUtility', visitId, 'getSelectedChannels', ex);
    }
    return channelSection;

}

export const getSelectedIntrnlChannels = (cartResponse,visitId=null) => {
    let channelSection = null;
    try{
        //get the service section data from the cart response 
        let service = getServiceSection(cartResponse,visitId);
        //find the international channel sub section
        if (InHomeUtils.isNotNull(service) && InHomeUtils.isNotNull(service.subSections) && InHomeUtils.isNotNull(service.subSections.subSection)) {
            let subSection = service.subSections.subSection;
            subSection.forEach(function (subSec) {
                if (subSec.sectionType != null && subSec.sectionType.toLowerCase().indexOf("intlpackage") > -1) {
                    channelSection = subSec.products;
                    return channelSection;
                }
            });
        }
    }
    catch (ex) {
        catchJSException('cartUtility', visitId, 'getSelectedIntrnlChannels', ex);
    }
    return channelSection;

}
export const getUnsupportedProductById = (id, productList, visitId=null) => {
    let product = '';
    try{
        if (InHomeUtils.isNotNull(productList) && InHomeUtils.isNotNull(productList.coreProduct)) {
            if (InHomeUtils.isNotNull(productList.coreProduct.data) && productList.coreProduct.data.length > 0) {
                productList.coreProduct.data.forEach(function (prod) {
                    if (InHomeUtils.isNotNull(prod) && prod.prodId === id) {
                        product = prod;
                        return product;
                    }
                });
            }
            if (InHomeUtils.isNotNull(productList.coreProduct.tv) && productList.coreProduct.tv.length > 0) {
                productList.coreProduct.tv.forEach(function (prod) {
                    if (InHomeUtils.isNotNull(prod) && prod.prodId === id) {
                        product = prod;
                        return product;
                    }
                });
            }
            if (InHomeUtils.isNotNull(productList.coreProduct.voice) && productList.coreProduct.voice.length > 0) {
                productList.coreProduct.tv.forEach(function (prod) {
                    if (InHomeUtils.isNotNull(prod) && prod.prodId === id) {
                        product = prod;
                        return product;
                    }
                });
            }
        }
        if (InHomeUtils.isNotNull(productList) && InHomeUtils.isNotNull(productList.subProduct)) {
            if (InHomeUtils.isNotNull(productList.subProduct.data) && productList.subProduct.data.length > 0) {
                productList.subProduct.data.forEach(function (prod) {
                    if (InHomeUtils.isNotNull(prod) && prod.prodId === id) {
                        product = prod;
                        return product;
                    }
                });
            }
            if (InHomeUtils.isNotNull(productList.subProduct.tv) && productList.subProduct.tv.length > 0) {
                productList.subProduct.tv.forEach(function (prod) {
                    if (InHomeUtils.isNotNull(prod) && prod.prodId === id) {
                        product = prod;
                        return product;
                    }
                });
            }
            if (InHomeUtils.isNotNull(productList.subProduct.voice) && productList.subProduct.voice.length > 0) {
                productList.subProduct.voice.forEach(function (prod) {
                    if (InHomeUtils.isNotNull(prod) && prod.prodId === id) {
                        product = prod;
                        return product;
                    }
                });
            }
        }
    }
    catch (ex) {
        catchJSException('cartUtility', visitId, 'getUnsupportedProductById', ex);
    }    
    return product;
}

export const getUnsupportedProducts = (cartResponse, dispatch, visitId,isSuppFlow=null) => {
   
    let cartProducts = '';
    let nonSupportedProducts = {
        coreProduct: { data: [], tv: [], voice: [] },
        subProduct: { data: [], tv: [], voice: [] },
        dataProducts: [], tvProducts: [], voiceProducts: [], prodsCount: 0
    }
    let isFeeWaived = false;
    let isData = false;
    let isTv = false;
    try{

        if (InHomeUtils.isNotNull(cartResponse) && InHomeUtils.isNotNull(cartResponse.cartTierPricing) && InHomeUtils.isNotNull(cartResponse.cartTierPricing.tierContent)) {
            cartProducts = getCartProducts(cartResponse.cartTierPricing,visitId);
        }
        if (InHomeUtils.isNotNull(cartProducts)) {
            if (InHomeUtils.isNotNull(cartProducts.Bundle) && InHomeUtils.isNotNull(cartProducts.Bundle.bundleProd) && cartProducts.Bundle.bundleProd.length > 0) {
                cartProducts.Bundle.bundleProd.forEach(prod =>{
                    if (InHomeUtils.isNotNull(prod) && InHomeUtils.isNotNull(prod.editLink)) {
                        if (prod.editLink === CartServices.dataPlans) {
                            isData = true;
                            if(InHomeUtils.isNotNull(prod.isProductSupported) && prod.isProductSupported === "No"){
                                nonSupportedProducts.coreProduct.data.push(prod);
                                nonSupportedProducts.dataProducts.push({
                                    id: (InHomeUtils.isNotNull(prod.prodId)) ? prod.prodId : "",
                                    description: (InHomeUtils.isNotNull(prod.prodName)) ? prod.prodName : "",
                                });
                                nonSupportedProducts.prodsCount++;
                            }
                        }
                        else if (prod.editLink === CartServices.tvPlans) {
                            isTv = true;
                            if(InHomeUtils.isNotNull(prod.isProductSupported) && prod.isProductSupported === "No"){
                                isFeeWaived = (prod.prodType === "SPORTSPASS" && prod.prodTypeVal === "ANNUALRENEWAL") ? true : false;
                                if(!isFeeWaived){
                                    nonSupportedProducts.coreProduct.tv.push(prod);
                                    nonSupportedProducts.tvProducts.push({
                                        id: (InHomeUtils.isNotNull(prod.prodId)) ? prod.prodId : "",
                                        description: (InHomeUtils.isNotNull(prod.prodName)) ? prod.prodName : "",
                                    });
                                    nonSupportedProducts.prodsCount++;
                                }
                            }
                        }
                        else if (prod.editLink === CartServices.voicePlans) {
                            if(InHomeUtils.isNotNull(prod.isProductSupported) && prod.isProductSupported === "No"){
                                nonSupportedProducts.coreProduct.voice.push(prod);
                                nonSupportedProducts.voiceProducts.push({
                                    id: (InHomeUtils.isNotNull(prod.prodId)) ? prod.prodId : "",
                                    description: (InHomeUtils.isNotNull(prod.prodName)) ? prod.prodName : "",
                                });
                                nonSupportedProducts.prodsCount++;
                            }
                        }
                    }
                })
            }
            else if (InHomeUtils.isNotNull(cartProducts.DataProduct) && InHomeUtils.isNotNull(cartProducts.DataProduct.dataProd) && cartProducts.DataProduct.dataProd.length > 0) {
                cartProducts.DataProduct.dataProd.forEach(prod =>{
                    isData = true;
                    if (InHomeUtils.isNotNull(prod) && InHomeUtils.isNotNull(prod.isProductSupported) && prod.isProductSupported === "No"){
                        nonSupportedProducts.subProduct.data.push(prod);
                        nonSupportedProducts.dataProducts.push({
                            id: (InHomeUtils.isNotNull(prod.prodId)) ? prod.prodId : "",
                            description: (InHomeUtils.isNotNull(prod.prodName)) ? prod.prodName : "",
                        });
                        nonSupportedProducts.prodsCount++;
                    }
                })
            }
            else if (InHomeUtils.isNotNull(cartProducts.TvProduct) && InHomeUtils.isNotNull(cartProducts.TvProduct.tvProd) && cartProducts.TvProduct.tvProd.length > 0) {
                cartProducts.TvProduct.tvProd.forEach(prod =>{
                    isTv = true;
                    if (InHomeUtils.isNotNull(prod) && InHomeUtils.isNotNull(prod.isProductSupported) && prod.isProductSupported === "No"){
                        isFeeWaived = (prod.prodType === "SPORTSPASS" && prod.prodTypeVal === "ANNUALRENEWAL") ? true : false;
                        if(!isFeeWaived){
                            nonSupportedProducts.coreProduct.tv.push(prod);
                            nonSupportedProducts.tvProducts.push({
                                id: (InHomeUtils.isNotNull(prod.prodId)) ? prod.prodId : "",
                                description: (InHomeUtils.isNotNull(prod.prodName)) ? prod.prodName : "",
                            });
                            nonSupportedProducts.prodsCount++;
                        }
                    }
                })
            }

            if (InHomeUtils.isNotNull(cartProducts.Techsure) && InHomeUtils.isNotNull(cartProducts.Techsure.VasProduct) && cartProducts.Techsure.VasProduct.length > 0 && (InHomeUtils.isNull(isSuppFlow)|| !isSuppFlow)) {
                cartProducts.Techsure.VasProduct.forEach(prod =>{
                    if (InHomeUtils.isNotNull(prod) && InHomeUtils.isNotNull(prod.isProductSupported) && prod.isProductSupported === "No"){
                        nonSupportedProducts.subProduct.data.push(prod);
                        nonSupportedProducts.dataProducts.push({
                            id: (InHomeUtils.isNotNull(prod.prodId)) ? prod.prodId : "",
                            description: (InHomeUtils.isNotNull(prod.prodName)) ? prod.prodName : "",
                        });
                        nonSupportedProducts.prodsCount++;
                    }
                })
            }

            if (InHomeUtils.isNotNull(cartProducts.Listing) && InHomeUtils.isNotNull(cartProducts.Listing.listingProd) && cartProducts.Listing.listingProd.length > 0) {
                cartProducts.Listing.listingProd.forEach(prod =>{
                    if (InHomeUtils.isNotNull(prod) && InHomeUtils.isNotNull(prod.isProductSupported) && prod.isProductSupported === "No"){
                        nonSupportedProducts.subProduct.voice.push(prod);
                        nonSupportedProducts.voiceProducts.push({
                            id: (InHomeUtils.isNotNull(prod.prodId)) ? prod.prodId : "",
                            description: (InHomeUtils.isNotNull(prod.prodName)) ? prod.prodName : "",
                        });
                        nonSupportedProducts.prodsCount++;
                    }
                })
            }
    
            if (InHomeUtils.isNotNull(cartProducts.Channels) && InHomeUtils.isNotNull(cartProducts.Channels.channelProd) && cartProducts.Channels.channelProd.length > 0) {
                cartProducts.Channels.channelProd.forEach(prod =>{
                    if (InHomeUtils.isNotNull(prod) && InHomeUtils.isNotNull(prod.isProductSupported) && prod.isProductSupported === "No"){
                        isFeeWaived = (prod.prodType === "SPORTSPASS" && prod.prodTypeVal === "ANNUALRENEWAL") ? true : false;
                        if(!isFeeWaived){
                            nonSupportedProducts.subProduct.tv.push(prod);
                            nonSupportedProducts.tvProducts.push({
                                id: (InHomeUtils.isNotNull(prod.prodId)) ? prod.prodId : "",
                                description: (InHomeUtils.isNotNull(prod.prodName)) ? prod.prodName : "",
                            });
                            nonSupportedProducts.prodsCount++;
                        }
                    }
                })
            }
                
            if (InHomeUtils.isNotNull(cartProducts.CartSubProduct)) {
                if (InHomeUtils.isNotNull(cartProducts.CartSubProduct.Equipment) && InHomeUtils.isNotNull(cartProducts.CartSubProduct.Equipment.equipment) && cartProducts.CartSubProduct.Equipment.equipment.length > 0) {
                    cartProducts.CartSubProduct.Equipment.equipment.forEach(prod =>{
                        if (InHomeUtils.isNotNull(prod) && InHomeUtils.isNotNull(prod.isProductSupported) && prod.isProductSupported === "No") {
                            if(isData){
                                nonSupportedProducts.subProduct.data.push(prod);
                                nonSupportedProducts.dataProducts.push({
                                    id: (InHomeUtils.isNotNull(prod.prodId)) ? prod.prodId : "",
                                    description: (InHomeUtils.isNotNull(prod.prodName)) ? prod.prodName : "",
                                });
                                nonSupportedProducts.prodsCount++;
                            }else if(isTv){
                                nonSupportedProducts.subProduct.tv.push(prod);
                                nonSupportedProducts.tvProducts.push({
                                    id: (InHomeUtils.isNotNull(prod.prodId)) ? prod.prodId : "",
                                    description: (InHomeUtils.isNotNull(prod.prodName)) ? prod.prodName : "",
                                });
                                nonSupportedProducts.prodsCount++;
                            }
                        }
                    })
                }
    
                if (InHomeUtils.isNotNull(cartProducts.CartSubProduct.OneTimeCharges) && InHomeUtils.isNotNull(cartProducts.CartSubProduct.OneTimeCharges.oneTimeCharge) && cartProducts.CartSubProduct.OneTimeCharges.oneTimeCharge.length > 0) {
                    cartProducts.CartSubProduct.OneTimeCharges.oneTimeCharge.forEach(prod =>{
                        if (InHomeUtils.isNotNull(prod) && InHomeUtils.isNotNull(prod.isProductSupported) && prod.isProductSupported === "No") {
                            let prType = InHomeUtils.isNotNull(prod.editLink) ? prod.editLink.toUpperCase() : "";
                            let prdType = InHomeUtils.isNotNull(prod.prodType) ? prod.prodType : "";
                            
                            if (prdType === "SPORTSPASS") {
                                isFeeWaived = (prod.prodType === "SPORTSPASS" && prod.prodTypeVal === "ANNUALRENEWAL") ? true : false;
                                if(!isFeeWaived){
                                    nonSupportedProducts.subProduct.tv.push(prod);
                                    nonSupportedProducts.tvProducts.push({
                                        id: (InHomeUtils.isNotNull(prod.prodId)) ? prod.prodId : "",
                                        description: (InHomeUtils.isNotNull(prod.prodName)) ? prod.prodName : "",
                                    });
                                    nonSupportedProducts.prodsCount++;
                                }
                            }
                            else if (prdType === "NETWORKEXTENDERNRC" || prdType === "NETWORKEXTENDER") {
                                isFeeWaived = (prod.prodType === "SPORTSPASS" && prod.prodTypeVal === "ANNUALRENEWAL") ? true : false;
                                if(!isFeeWaived){
                                    if(isData){
                                        nonSupportedProducts.subProduct.data.push(prod);
                                        nonSupportedProducts.dataProducts.push({
                                            id: (InHomeUtils.isNotNull(prod.prodId)) ? prod.prodId : "",
                                            description: (InHomeUtils.isNotNull(prod.prodName)) ? prod.prodName : "",
                                        });
                                        nonSupportedProducts.prodsCount++;
                                    }else if(isTv){
                                        nonSupportedProducts.subProduct.tv.push(prod);
                                        nonSupportedProducts.tvProducts.push({
                                            id: (InHomeUtils.isNotNull(prod.prodId)) ? prod.prodId : "",
                                            description: (InHomeUtils.isNotNull(prod.prodName)) ? prod.prodName : "",
                                        });
                                        nonSupportedProducts.prodsCount++;
                                    }
                                }
                            }
                            else if (prType === "") {
                                nonSupportedProducts.subProduct.data.push(prod);
                                nonSupportedProducts.dataProducts.push({
                                    id: (InHomeUtils.isNotNull(prod.prodId)) ? prod.prodId : "",
                                    description: (InHomeUtils.isNotNull(prod.prodName)) ? prod.prodName : "",
                                });
                                nonSupportedProducts.prodsCount++;
                            }
                        }
                    })
                }
            }
            dispatch({ type: 'UPDATE_UNSUPPORTED_PRODUCTS', value: nonSupportedProducts })
            // Changes for  PR00032100  HBO Only
            if (InHomeUtils.isNull(isSuppFlow) && InHomeUtils.isNotNull(nonSupportedProducts) && InHomeUtils.isNotNull(nonSupportedProducts.subProduct) && InHomeUtils.isNotNull(nonSupportedProducts.subProduct.tv) && nonSupportedProducts.subProduct.tv.length > 0) {
                const hboUnSupportedProduct = nonSupportedProducts.subProduct.tv.filter(p => (InHomeUtils.isNotNull(p.prodType) && InHomeUtils.isNotEmpty(p.prodType) && p.prodType.toLowerCase() === "premium" && InHomeUtils.isNotNull(p.prodTypeVal) && InHomeUtils.isNotEmpty(p.prodTypeVal)
                && p.prodTypeVal.toLowerCase() === "hbo" && InHomeUtils.isNotNull(p.prodName) && InHomeUtils.isNotEmpty(p.prodName)&& p.prodName.toLowerCase().indexOf("hbo") > -1 && InHomeUtils.isNotNull(p.isProductSupported) && InHomeUtils.isNotEmpty(p.isProductSupported) && p.isProductSupported.toLowerCase() === "no"));
                if (hboUnSupportedProduct.length > 0) {
                    let hboUnSupportedNotificationInfo = {
                        removeChannel: hboUnSupportedProduct[0].prodId,
                        showNotification: false
                    }
                    dispatch({ type: 'HBOUNSUPPORTED_NOTIFICATION', value: hboUnSupportedNotificationInfo });
                }
            }
        }
    }
    catch (ex) {
        catchJSException('cartUtility', visitId, 'action-getUnsupportedProducts', ex);
    }
    
    return nonSupportedProducts.prodsCount > 0 ? true : false;
};
